import { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

type Props = {
  titleIntlId?: string;
  title?: string;
};

const PageTitle = (props: Props) => {
  const { titleIntlId, title } = props;
  const { formatMessage } = useIntl();
  const siteName = formatMessage({ id: 'tinder' });

  const titleString = titleIntlId ? formatMessage({ id: titleIntlId }) : title;

  if (!titleString) {
    // no override, use App level Meta
    return null;
  }

  return (
    <Helmet>
      <title>{`${titleString} | ${siteName}`}</title>
    </Helmet>
  );
};

export default memo(PageTitle);
